import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { AuthSelector, WalletAction, WalletSelector } from "@obg/ngx.core";
import { CoreContentState } from "@obg/ngx.core.content";
import { fromMillisecondsToMinutes } from "@obg/ngx.global";
import { ignoreNil } from "@obg/rxjs";
import { map, switchMap, take, tap } from "rxjs/operators";

import { GamblingSummary } from "./gambling-summary-modal.model";

@Component({
	selector: "obg-gambling-summary-modal",
	templateUrl: "./gambling-summary-modal.container.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class GamblingSummaryModalContainer {
	@HostBinding("class.obg-gambling-summary-modal") hostCssClass = true;

	gamblingSummary$ = this.store.select(AuthSelector.getSessionElapsedTimeInMillis).pipe(
		ignoreNil(),
		take(1),
		map((sessionElapsedTimeInMillis) => Math.ceil(fromMillisecondsToMinutes(sessionElapsedTimeInMillis))),
		tap((sessionElapsedTimeInMinutes) =>
			this.store.dispatch(this.walletAction.getBetWinSummary(sessionElapsedTimeInMinutes))
		),
		switchMap(() => this.store.select(this.walletSelector.getBetWinSummary())),
		ignoreNil(),
		map(
			(betWinSummary) =>
				({
					totalBets: betWinSummary.totalBets,
					netWinning:
						betWinSummary.netWinning > 0
							? `+${betWinSummary.netWinning}`
							: betWinSummary.netWinning.toString(),
					currencyCode: betWinSummary.currencyCode,
				}) as GamblingSummary
		)
	);

	constructor(
		private store: Store<CoreContentState>,
		private walletAction: WalletAction,
		private walletSelector: WalletSelector
	) {}
}
